import createInstance from "./instance";
import crops from "./crops";
import { CropsSvc } from "./schemas";

const cropsSvc: CropsSvc = {
  createInstance,
  getCrops: crops.getCrops,
};

export default cropsSvc;

export * from "./instance";
export * from "./schemas";
